import { DefaultAvatar } from 'atoms/default-avatar';

export default function ({ item, isLoading }) {
  if (isLoading) return 'loading';

  return (
    <div className="flex-row">
      <DefaultAvatar
        size="small"
        avatar={item.user.links?.image?.desktop?.small}
      />
      <div className="ml-8">
        <p className="bold">{item.user.firstName}</p>
        <span className="f11 c-primary-purple">{item.role.value}</span>
      </div>
    </div>
  );
}
